module.exports = __webpack_public_path__ + "static/media/white-green-tick.282199cb.svg";